import capitalizeFirstLetter from './capitalizeFirstLetter';

export default function toCamelCase(string) {
  return string.split('_').map(word => capitalizeFirstLetter(word)).join('');
}